<template>
  <div class="w-100">
    <template v-if="show">
    <div class="row">
      <div class="col-4">
        <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
          <h2 class="card-title font-weight-bolder">{{ $t('title.current_balances') }}</h2>
        </div>
      </div>
      <div class="col-8">
        <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
          <h2 class="card-title font-weight-bolder">{{ $t('title.filters') }}</h2>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <div class="questions sygni-grid">
          <div class="">
            <div class="row filters">
              <div class="col-4">
                <template v-if="selectOptions.walletCurrency.length">
                  <table class="table table-striped table-sm" :class="{'mb-4': index === 0}"  v-for="(wallet, index) in selectOptions.walletCurrency" :key="index">
                    <tbody>
                    <tr :class="{'quiz-coins': wallet.symbol.symbol === 'QUIZ_COINS', 'free-coins': wallet.symbol.symbol === 'FUN_COINS'}">
                      <td class="font-weight-bolder">{{ $t('table.label.wallet_currency') }}</td>
                      <td>{{ $t(wallet.symbol.symbol) }}</td>
                    </tr>
                    <tr>
                      <td class="font-wei§ght-bolder">{{ $t('table.label.total_balance') }}</td>
                      <td>{{ wallet.realMoneyBalanceAmount.amount | numberFormat }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bolder">{{ $t('table.label.locked_funds') }}</td>
                      <td>{{ wallet.realMoneyLockedFoundsAmount.amount | numberFormat }}</td>
                    </tr>
                    <tr v-if="wallet.symbol.symbol !== 'FC'">
                      <td class="font-weight-bolder">{{ $t('table.label.bonuses') }}</td>
                      <td>-</td>
                    </tr>
                    <tr v-if="wallet.symbol.symbol !== 'FC'">
                      <td class="font-weight-bolder">{{ $t('table.label.available_to_withdraw') }}</td>
                      <td>-</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              </div>
              <div class="col-8">
                <div class="" v-if="selectOptions.walletCurrency.length">
                  <div class="row">
                    <div class="col-6">
                      <filter-select
                          :emit-event-value="true"
                          :filter-query="filterQuery"
                          :options="selectOptions.walletCurrency"
                          ref="currency-ref"
                          :multiple="false"
                          options-label="text"
                          options-track-by="value"
                          filter-name="walletCurrency"
                          :label="$t('filters.label.wallet_currency')"
                          :placeholder="$t('filters.placeholder.wallet_currency')">
                      </filter-select>
                    </div>
                    <div class="col-6">

                      <filter-select
                          :filter-query="filterQuery"
                          :options="selectOptions.type"
                          :multiple="false"
                          :emit-event-value="true"
                          @changedFilterValue="applyFilters"
                          options-label="text"
                          options-track-by="value"
                          filter-name="operationType"
                          :label="$t('filters.label.operation_type')"
                          :placeholder="$t('filters.placeholder.operation_type')">
                      </filter-select>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">

                      <filter-input-with-operator
                          :filter-query="filterQuery"
                          :operator-options="selectOptions.comparisonOperator"
                          :operator-multiple="false"
                          :default-operator="{value: 'eq', text: 'equales'}"
                          :restrict-input="true"
                          restriction-type="numbers"
                          filter-name="operationAmount"
                          :label="$t('filters.label.operation_amount')">
                      </filter-input-with-operator>

                    </div>
                    <div class="col-6">
                      <filter-date-range-picker
                          :filter-query="filterQuery"
                          :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                          :auto="true"
                          :linked="false"
                          :time-picker="true"
                          filter-name="operationCreatedAt"
                          open-direction="left"
                          :label="$t('filters.label.operation_date')">
                      </filter-date-range-picker>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="float-right">
                        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
                        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
                      </div>
                    </div>
                  </div> <!-- #row-->
                </div> <!-- #filters-->
              </div>
            </div>

            <div class="row mt-2">


              <div class="col-12">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

                <div class="table-responsive">
                  <b-table striped show-empty
                           :empty-text="$t('table.no_results')"
                           :busy="isBusy"
                           hover
                           head-variant="dark"
                           outlined
                           :sort-by.sync="orderColumn"
                           :sort-desc.sync="orderDirection"
                           :no-local-sorting="true"
                           :items="items"
                           :fields="fields">

                    <template v-for='dateSlot in ["operationCreatedAt"]'
                              v-slot:[`cell(${dateSlot})`]="data">
                      <template v-if="data.value"> {{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }} </template>
                    </template>

                    <template #cell(operationType)="data">
                      <div :id="data.item.id">{{ $t(data.value) }} <b-icon-info-circle-fill class="ml-2" v-if="data.item.comment"></b-icon-info-circle-fill> </div>
                      <b-tooltip v-if="data.item.comment" :target="data.item.id" triggers="hover">
                        {{data.item.comment}} <br/> created by: {{data.item.createdBy}}
                      </b-tooltip>
                    </template>

                    <template v-for='idSlot in ["id","gameId"]'
                              v-slot:[`cell(${idSlot})`]="data">
                      {{ data.value | shortId }}
                    </template>

                    <template v-for='numberSlot in ["operationAmount","walletBalanceAmount","walletLockedFoundsAmount",]'
                              v-slot:[`cell(${numberSlot})`]="data">
                      {{ data.value | numberFormat }}
                    </template>

                    <template #cell(transactionId)="data">
                      <div>
                        <router-link
                            :to="{ name: 'player-transactions', query: { transactionId: data.item.transactionId }}">
                          {{ data.value | shortId }}</router-link>
                      </div>

                    </template>
                    <template #cell(gameId)="data">
                      <div>
                        <router-link
                            :to="{ name: 'player-game-history', query: { gameId: data.item.gameId }}">
                          {{ data.value | shortId }}</router-link>
                      </div>

                    </template>
                    <template #cell(walletCurrency)="data">
                      {{ $t(data.value) }}
                    </template>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{$t('state.loading')}}</strong>
                      </div>
                    </template>

                  </b-table>
                </div> <!-- #table-responsive-->

                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>
              </div>
            </div>
          </div> <!-- #card-body-->
        </div> <!-- #card questions sygni-grid-->
      </div>
    </div>
    </template>
    <div class="spinner-wrapper" v-if="showLoading">
      <b-spinner></b-spinner>
    </div>
    <div class="spinner-wrapper" v-if="!showLoading && items.length === 0">
      {{ $t('player.wallet.no_wallets') }}
    </div>
  </div>

</template>

<script>

import GridMixin from "../../../components/grid/GridMixin";
import FilterInputWithOperator from "../../../components/grid/filters/FilterInputWithOperator";
import FilterDateRangePicker from "../../../components/grid/filters/FilterDateRangePicker";
import FilterSelect from "../../../components/grid/filters/FilterSelect";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";


export default {
  mixins: [GridMixin],
  components: {
    FilterSelect,
    FilterInputWithOperator,
    FilterDateRangePicker,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: null,
      wallets: null,
      walletCurrency: null,
      show: false,
      showLoading: true,
      orderColumn: 'operationCreatedAt',
      fields: [
        {key: 'id', label: this.$t('table.header.operation_id')},
        {key: 'gameId', label: this.$t('table.header.game_id')},
        {key: 'transactionId', label: this.$t('table.header.transaction_id')},
        {key: 'walletCurrency', label: this.$t('table.header.wallet_currency')},
        {key: 'operationType', label: this.$t('table.header.operation_type')},
        {key: 'operationAmount', label: this.$t('table.header.operation_amount'), sortable: true },
        {key: 'walletBalanceAmount', label: this.$t('table.header.available_balance_after'), sortable: true},
        {key: "walletLockedFoundsAmount", label: this.$t('table.header.remaining_locked_balance'), sortable: true},
        {key: 'operationCreatedAt', label: this.$t('table.header.operation_date'),sortable: true},
      ],
      items: [],
      selectOptions: {
        walletCurrency: [

        ],
        type: [
        ],
        containOperator: [
          {value: 'eq', text: this.$t('operator.contains')},
          {value: 'neq', text: this.$t('operator.not_contains')},
        ],
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ]
      },
    };
  },
  mounted() {
    this.getOperationTypes();
    const userIdFromUrl = this.$route.params.id;
    this.$store.dispatch('players/getPlayerWallet', userIdFromUrl).then(() => {
      this.showLoading = false;
    });
  },
  methods: {
    checkPlayerData() {
      if (this.player
          && this.player.id
          // eslint-disable-next-line no-prototype-builtins
          && this.player.hasOwnProperty('wallets')
          && this.player.wallets
          && this.player.wallets.length) {

        const wallets = this.player.wallets;

        this.selectOptions.walletCurrency = wallets.map(w => {
          return {
            value: w.symbol.symbol,
            text: this.$t(w.symbol.symbol),
            ...w
          }
        });
        this.getWallets(this.$route.params.id);

        this.show = true;
      }
    },
    getOperationTypes() {
      this.$store.dispatch('root/getWalletDictionary')
          .then(
              data => {
                this.selectOptions.type = data['walletEntryOperationType'].map(d => {
                  return {text: this.$t(d), value: d};
                });
              }
          )
    },
    changeCurrency($e) {
      this.getWallets($e.value);
    },
    getWallets(id) {
      this.gridGetUrl = `/api/owner/${id}/wallet/history`;
      this.loadItems();
    }
  },
  watch: {
    player: function () {
      this.checkPlayerData();
    }
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    },
    tenant: function () {
      return this.$store.getters['root/tenant'];
    }
  }
}
</script>
